import React, { useState } from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { Auth } from "../../../../api";
import { initialValues, validationSchema } from "./RegisterForm.Form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Asegúrate de importar los estilos de toastify
import "./RegisterForm.scss";

const authController = new Auth();

export function RegisterForm(proprs) {
  const { openLogin } = proprs;

  const [error, setError] = useState("");
  const [verificationSent, setVerificationSent] = useState(false); // Estado para saber si se ha enviado verificación
  const [codeExpired, setCodeExpired] = useState(false); // Estado para saber si el código ha expirado

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(verificationSent), // Pasamos verificationSent al esquema de validación
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        setError("");
        setCodeExpired(false); // Reiniciar el estado de código expirado
        if (!verificationSent) {
          // Primer paso: registro del usuario y envío del correo de verificación
          const response = await authController.register(formValue);
          authController.setAccessToken(response.access);
          authController.setUserId(response.user_id);
          setVerificationSent(true); // Marcamos que se ha enviado el correo de verificación
        } else {
          // Segundo paso: verificación del código
          const accessToken = authController.getAccessToken();
          const id = authController.getUserId();
          const codeNumber = formik.values.code; // Usamos el código del formulario
          await authController.verify(id, accessToken, codeNumber);
          openLogin(); // Si la verificación es exitosa, abrimos el login
        }
      } catch (error) {
        if (error.message.includes("expirado")) {
          setCodeExpired(true); // Si el código ha expirado, cambiar el estado
        }
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false, // Para que el usuario tenga que cerrarlo manualmente
          closeOnClick: true,
        });
      }
    },
  });

  // Función para solicitar un nuevo código
  const handleResendCode = async () => {
    try {
      const accessToken = authController.getAccessToken();
      const id = authController.getUserId();
      await authController.resendCode(id, accessToken); // Llamar a la función del backend
      toast.success("Nuevo código enviado. Revisa tu email.");
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <>
      <ToastContainer />

      <Form onSubmit={formik.handleSubmit}>
        {!verificationSent && (
          <>
            <Form.Input
              name="email"
              type="text"
              placeholder="Correo Electrónico"
              onChange={formik.handleChange}
              value={formik.values.email}
              error={
                formik.errors.email ? { content: formik.errors.email } : null
              }
            />
            <Form.Input
              name="password"
              type="password"
              placeholder="Contraseña"
              onChange={formik.handleChange}
              value={formik.values.password}
              error={
                formik.errors.password
                  ? { content: formik.errors.password }
                  : null
              }
            />
            <Form.Input
              name="repeatPassword"
              type="password"
              placeholder="Repetir Contraseña"
              onChange={formik.handleChange}
              value={formik.values.repeatPassword}
              error={
                formik.errors.repeatPassword
                  ? { content: formik.errors.repeatPassword }
                  : null
              }
            />
            <Form.Checkbox
              name="conditionsAccepted"
              label="Acepto los términos y condiciones"
              onChange={(e, data) =>
                formik.setFieldValue("conditionsAccepted", data.checked)
              }
              checked={formik.values.conditionsAccepted}
              error={
                formik.errors.conditionsAccepted
                  ? { content: formik.errors.conditionsAccepted }
                  : null
              }
            />
            <Button type="submit" primary fluid loading={formik.isSubmitting}>
              Confirmar correo
            </Button>
          </>
        )}

        {verificationSent && (
          <>
            <p>Ingresa el código que recibiste por e-mail</p>
            <div className="verification-code">
              <Form.Input
                name="code"
                type="text"
                placeholder="Código de 6 dígitos"
                onChange={formik.handleChange}
                value={formik.values.code}
                error={
                  formik.errors.code ? { content: formik.errors.code } : null
                }
              />
            </div>
            {codeExpired && (
              <p>
                El código ha expirado.{" "}
                <button
                  type="button"
                  onClick={handleResendCode}
                  style={{
                    background: "none",
                    border: "none",
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Haz clic aquí para solicitar uno nuevo
                </button>
              </p>
            )}
            <Button type="submit" primary fluid loading={formik.isSubmitting}>
              Confirmar cuenta
            </Button>
          </>
        )}

        {error && <p className="register-form__error">{error}</p>}
      </Form>
    </>
  );
}
